import React, { Component } from "react";

import "./administrador.css";

import {
    Button,
    ModalHeader,
    ModalBody,
    ModalFooter,
    FormGroup,
    Label,
    Col,
    Input
} from 'reactstrap';

import Utils from "../../Utils";

import { Cargando } from '../estados/Cargando';

export class Semaforos extends Component {

    constructor(props) {
        super(props);

        this.state = {
            modalSem: props.modalSem,
            semaforos: [],
            factoresResta: [],
            estado: false,
            rol: props.rol
        };
    }

    componentDidMount() {
        this.getSemaforos();
    }

    toggle() {
        this.props.modalSem();
    }

    verificarSemaforosFactores(factores) {

        for (const factor of factores) {

            const {
                nombre,
                verdeDesde,
                verdeHasta,
                amarilloDesde,
                amarilloHasta,
                rojoDesde,
                rojoHasta
            } = factor;

            if (!(verdeDesde > amarilloHasta)) {
                alert(`Error en "${nombre}": verdeDesde (${verdeDesde}) debe ser mayor que amarilloHasta (${amarilloHasta})`);
                throw new Error(`Semáforo inválido en "${nombre}"`);
            }

            if (!(amarilloHasta > amarilloDesde)) {
                alert(`Error en "${nombre}": amarilloHasta (${amarilloHasta}) debe ser mayor que amarilloDesde (${amarilloDesde})`);
                throw new Error(`Semáforo inválido en "${nombre}"`);
            }

            if (!(amarilloDesde > rojoHasta)) {
                alert(`Error en "${nombre}": amarilloDesde (${amarilloDesde}) debe ser mayor que rojoHasta (${rojoHasta})`);
                throw new Error(`Semáforo inválido en "${nombre}"`);
            }

            if (!(rojoHasta > rojoDesde)) {
                alert(`Error en "${nombre}": rojoHasta (${rojoHasta}) debe ser mayor que rojoDesde (${rojoDesde})`);
                throw new Error(`Semáforo inválido en "${nombre}"`);
            }
        }
    }

    async getSemaforos() {

        this.setState({ estado: false });

        await Utils.getFactoresSuma()
            .then(data => {

                console.log("Factores suma recibidos:", data);

                // RF14: sólo se configuran los 3 factores definidos en RF03.
                // Performance -> factores[4]
                // Auditoría técnica -> factores[0]
                // Situación Laboral y Previsional -> factores[6]

                const factores = [
                    data[4],
                    data[0],
                    data[6]
                ];

                this.setState({
                    semaforos: factores
                });
            });

        await Utils.getFactoresResta()
            .then(data => {
                console.log("Factores resta recibidos:", data);
                if (data !== undefined) {

                    this.setState({
                        factoresResta: data
                    });
                }
            });

        this.setState({
            estado: true
        });
    }

    actualizarValor(nuevoValor, factorIndex, campo) {

        let valor = nuevoValor.value.replace(/[^0-9]/g, '');

        if (Number(valor) > 99) {
            valor = 99;
        }

        if (Number(valor) < 3) {
            valor = 2;
        }

        valor = Number(valor);

        const factores = [...this.state.semaforos];

        factores[factorIndex] = {
            ...factores[factorIndex],
            [campo]: valor
        };
        if (campo === "amarilloDesde") {
            factores[factorIndex].rojoHasta = valor - 1;
        }
        if (campo === "verdeDesde") {
            factores[factorIndex].amarilloHasta = valor - 1;
        }

        this.setState({
            semaforos: factores
        });
    }

    actualizarTexto(nuevoValor, factorIndex, campo) {

        const factores = [...this.state.semaforos];

        factores[factorIndex] = {
            ...factores[factorIndex],
            [campo]: nuevoValor.value
        };

        this.setState({
            semaforos: factores
        });
    }

    actualizarFactorResta(nuevoValor, factorIndex, campo) {

        const factores = [...this.state.factoresResta];

        factores[factorIndex] = {
            ...factores[factorIndex],
            [campo]: nuevoValor
        };

        this.setState({
            factoresResta: factores
        });
    }

    async sendForm() {

        // Factores que suman
        // RF14: sólo se envían los 3 factores configurados en la vista.
        const items = this.state.semaforos.map(factor => ({
            id: factor.id,
            nombre: factor.nombre,
            semaforoVerde: factor.semaforoVerde,
            verdeDesde: Number(factor.verdeDesde),
            verdeHasta: Number(factor.verdeHasta),
            semaforoAmarillo: factor.semaforoAmarillo,
            amarilloDesde: Number(factor.amarilloDesde),
            amarilloHasta: Number(factor.amarilloHasta),
            semaforoRojo: factor.semaforoRojo,
            rojoDesde: Number(factor.rojoDesde),
            rojoHasta: Number(factor.rojoHasta),
            textoBoton: factor.textoBoton,
            vinculoBoton: factor.vinculoBoton
        }));

        // items es un array con los valores que se evaluan en el semaforo
        this.verificarSemaforosFactores(items);

        const payload = JSON.stringify(items);

        if (this.state.rol === "A") {
            await Utils.setFactoresSuma(payload);
        }

        // Factores que restan
        const itemsResta = this.state.factoresResta.map(factor => ({
            id: factor.id,
            nombre: factor.nombre,
            descripcionBien: factor.descripcionBien,
            descripcionMal: factor.descripcionMal,
            semaforo: factor.semaforo,
            rojoDesde: Number(factor.rojoDesde),
            rojoHasta: Number(factor.rojoHasta),
            textoBoton: factor.textoBoton,
            vinculoBoton: factor.vinculoBoton
        }));

        const payloadResta = JSON.stringify(itemsResta);

        if (this.state.rol === "A") {
            await Utils.setFactoresResta(payloadResta);
        }

        this.toggle();
    }

    renderFactorSuma(factor, i) {

        return (
            <div className="semaforoFactor" key={factor.id || i}>

                <div className="nombreEdit">

                    <FormGroup row>

                        <Label sm={2}>
                            Nombre
                        </Label>

                        <Col sm={10}>

                            <Input
                                type="text"
                                name="nombre"
                                value={factor.nombre || ""}
                                readOnly={this.state.rol === "V"}
                                onChange={(e) =>
                                    this.actualizarTexto(
                                        e.target,
                                        i,
                                        "nombre"
                                    )
                                }
                            />

                        </Col>

                    </FormGroup>

                </div>

                <div className="semaforoValores">

                    <div className="semaforoColumna semV">

                        <textarea
                            rows="4"
                            name="semaforoVerde"
                            value={factor.semaforoVerde || ""}
                            readOnly={this.state.rol === "V"}
                            onChange={(e) =>
                                this.actualizarTexto(
                                    e.target,
                                    i,
                                    "semaforoVerde"
                                )
                            }
                        />

                        <div className="semaforoValoresNumericos">

                            <div>
                                Desde:
                                <input
                                    type="number"
                                    name="verdeDesde"
                                    value={factor.verdeDesde}
                                    min="3"
                                    max="99"
                                    disabled={this.state.rol === "V"}
                                    onChange={(e) =>
                                        this.actualizarValor(
                                            e.target,
                                            i,
                                            "verdeDesde"
                                        )
                                    }
                                />
                            </div>

                            <div>
                                Hasta:
                                <input
                                    type="number"
                                    name="verdeHasta"
                                    value={factor.verdeHasta}
                                    disabled
                                    readOnly
                                />
                            </div>

                        </div>

                    </div>


                    <div className="semaforoColumna semA">

                        <textarea
                            rows="4"
                            name="semaforoAmarillo"
                            value={factor.semaforoAmarillo || ""}
                            readOnly={this.state.rol === "V"}
                            onChange={(e) =>
                                this.actualizarTexto(
                                    e.target,
                                    i,
                                    "semaforoAmarillo"
                                )
                            }
                        />

                        <div className="semaforoValoresNumericos">

                            <div>
                                Desde:
                                <input
                                    type="number"
                                    name="amarilloDesde"
                                    value={factor.amarilloDesde}
                                    min="2"
                                    max="99"
                                    disabled={this.state.rol === "V"}
                                    onChange={(e) =>
                                        this.actualizarValor(
                                            e.target,
                                            i,
                                            "amarilloDesde"
                                        )
                                    }
                                />
                            </div>

                            <div>
                                Hasta:
                                <input
                                    type="number"
                                    name="amarilloHasta"
                                    value={factor.amarilloHasta}
                                    disabled
                                    readOnly
                                />
                            </div>

                        </div>

                    </div>


                    <div className="semaforoColumna semR">

                        <textarea
                            rows="4"
                            name="semaforoRojo"
                            value={factor.semaforoRojo || ""}
                            readOnly={this.state.rol === "V"}
                            onChange={(e) =>
                                this.actualizarTexto(
                                    e.target,
                                    i,
                                    "semaforoRojo"
                                )
                            }
                        />

                        <div className="semaforoValoresNumericos">

                            <div>
                                Desde:
                                <input
                                    type="number"
                                    name="rojoDesde"
                                    value={factor.rojoDesde}
                                    disabled
                                    readOnly
                                />
                            </div>

                            <div>
                                Hasta:
                                <input
                                    type="number"
                                    name="rojoHasta"
                                    value={factor.rojoHasta}
                                    disabled
                                    readOnly
                                />
                            </div>

                        </div>

                    </div>

                </div>

            </div>
        );
    }

    renderFactorResta(factor, i) {
        return (
            <div className="factorResta semN" key={factor.id || i}>
                <div className="factorRestaNombre">
                    <FormGroup row>
                        <Label sm={3}>
                            Nombre
                        </Label>
                        <Col sm={9}>
                            <Input
                                type="text"
                                name="nombre"
                                value={factor.nombre || ""}
                                readOnly={this.state.rol !== "A"}
                                onChange={(e) =>
                                    this.actualizarFactorResta(
                                        e.target.value,
                                        i,
                                        "nombre"
                                    )
                                }
                            />
                        </Col>
                    </FormGroup>
                </div>
                <div className="factorRestaDescripciones">
                    <div className="factorRestaDescripcionBox">
                        <Label>
                            Descripción bien
                        </Label>
                        <textarea
                            rows="5"
                            name="descripcionBien"
                            value={factor.descripcionBien || ""}
                            readOnly={this.state.rol !== "A"}
                            onChange={(e) =>
                                this.actualizarFactorResta(
                                    e.target.value,
                                    i,
                                    "descripcionBien"
                                )
                            }
                        />
                    </div>
                    <div className="factorRestaDescripcionBox">
                        <Label>
                            Descripción mal
                        </Label>
                        <textarea
                            rows="5"
                            name="descripcionMal"
                            value={factor.descripcionMal || ""}
                            readOnly={this.state.rol !== "A"}
                            onChange={(e) =>
                                this.actualizarFactorResta(
                                    e.target.value,
                                    i,
                                    "descripcionMal"
                                )
                            }
                        />
                    </div>
                </div>
                <input
                    type="hidden"
                    name="id"
                    value={factor.id || ""}
                    readOnly
                />
                <input
                    type="hidden"
                    name="textoBoton"
                    value={factor.textoBoton || ""}
                    readOnly
                />
                <input
                    type="hidden"
                    name="vinculoBoton"
                    value={factor.vinculoBoton || ""}
                    readOnly
                />
            </div>
        );
    }


    render() {

        if (!this.state.estado) {
            return <Cargando />;
        }

        return (

            <div>

                <ModalHeader toggle={() => this.toggle()}>
                    Valores de semáforos
                </ModalHeader>

                <ModalBody className="semaforosModalBody">

                    {/* FACTORES QUE SUMAN */}

                    <div className="seccionSemaforos">

                        <div className="seccionTitulo">
                            Factores que suman
                        </div>

                        {this.state.semaforos.map((factor, i) =>
                            this.renderFactorSuma(factor, i)
                        )}

                    </div>


                    {/* FACTORES QUE RESTAN */}

                    <div className="seccionSemaforos seccionResta">

                        <div className="seccionTitulo">
                            Factores que restan
                        </div>

                        <div className="factoresRestaGrid">

                            {this.state.factoresResta.map((factor, i) =>
                                this.renderFactorResta(factor, i)
                            )}

                        </div>

                    </div>

                </ModalBody>

                <ModalFooter>

                    {this.state.rol === "A" &&

                        <Button
                            color="primary"
                            onClick={() => this.sendForm()}
                        >
                            Guardar
                        </Button>

                    }

                    <Button
                        color="secondary"
                        onClick={() => this.toggle()}
                    >
                        Cerrar
                    </Button>

                </ModalFooter>

            </div>
        );
    }

}